var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.4738 1.98804C14.5192 1.98804 14.5637 1.99205 14.6069 1.99974H14.7365C14.9407 1.99974 15.136 2.08249 15.2775 2.22888L20.3435 7.47277C20.4776 7.6116 20.5525 7.79661 20.5525 7.98907V17.2345C20.5525 19.6994 18.5411 21.7319 16.0725 21.7319H8.08449C5.48593 21.7319 3.50049 19.801 3.50049 17.2345V6.45148C3.50049 4.00499 5.59651 1.99974 8.08449 1.99974H14.3407C14.3839 1.99205 14.4284 1.98804 14.4738 1.98804ZM8.08449 3.49054L13.7238 3.48974V5.62477L13.729 5.81203C13.8265 7.54747 15.2709 8.92582 17.0412 8.92954C17.4629 8.93049 17.8422 8.93119 18.1757 8.9316L19.052 8.92863L19.0525 17.2344C19.0525 18.8814 17.707 20.241 16.0725 20.241H8.08449C6.30715 20.241 5.00049 18.9702 5.00049 17.2344V6.45141C5.00049 4.84131 6.4124 3.49054 8.08449 3.49054ZM17.0445 7.43867L18.231 7.4385L15.2238 4.32578V5.62477C15.2238 6.62521 16.0381 7.43655 17.0445 7.43867ZM15.0441 13.6636C15.0441 13.2519 14.7083 12.9181 14.2941 12.9181H9.39309L9.29132 12.9249C8.92524 12.9743 8.64309 13.2862 8.64309 13.6636C8.64309 14.0752 8.97887 14.409 9.39309 14.409H14.2941L14.3959 14.4022C14.7619 14.3528 15.0441 14.0409 15.0441 13.6636Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftIcon);
export default __webpack_public_path__ + "static/media/draft_Icon.e798f3a73ede225db3870e4bef0475ca.svg";
export { ForwardRef as ReactComponent };